<template>
  <div class="authority-container">
    <div class="authority-header">
      <h2>权限配置管理</h2>
      <el-button type="primary" @click="handleAddUser">添加人员权限</el-button>
    </div>

    <el-table v-loading="loading" :data="userList" border style="width: 100%">
      <el-table-column label="菜单名称" prop="menuName">
        <template slot-scope="scope">
          <el-tag v-for="menu in scope.row.menuName" :key="menu" style="margin-right: 5px">
            {{ menu }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="人员名称" prop="name" />
      <el-table-column label="创建时间" prop="created_at">
        <template slot-scope="scope">
          {{ $moment(scope.row.created_at).format('YYYY-MM-DD HH:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column label="更新时间" prop="updated_at">
        <template slot-scope="scope">
          {{ $moment(scope.row.updated_at).format('YYYY-MM-DD HH:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column label="权限编辑状态">
        <template slot-scope="scope">
          <div class="permission-status">
            <el-switch
              v-model="scope.row.editPermission"
              active-text="编辑权限"
              @change="(val) => handlePermissionChange(scope.row, 'all', 'edit')"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button size="mini" type="text" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="text" class="delete-btn" @click="handleDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 添加/编辑对话框 -->
    <el-dialog
      :title="dialogType === 'add' ? '添加人员权限' : '编辑人员权限'"
      :visible.sync="dialogVisible"
      width="500px"
    >
      <el-form :model="form" ref="form" :rules="rules" label-width="100px">
        <el-form-item label="人员名称" prop="name">
          <el-select
            v-model="form.name"
            placeholder="请选择人员"
            style="width: 100%"
            :disabled="dialogType === 'edit'"
          >
            <el-option v-for="item in availableUsers" :key="item" :label="item" :value="item" />
          </el-select>
        </el-form-item>
        <el-form-item label="菜单权限">
          <el-checkbox-group v-model="form.menuName">
            <el-checkbox label="资源管理" />
            <el-checkbox label="员工信息" />
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="编辑权限">
          <el-switch v-model="form.editPermission" active-text="允许编辑" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getAuthorityList, createAuthority, updateAuthority, deleteAuthority } from '@/api/auth';
export default {
  name: 'AuthorityManage',
  data() {
    return {
      loading: false,
      userList: [],
      dialogVisible: false,
      dialogType: 'add', // 'add' or 'edit'
      availableUsers: ['卢旭', '朱泳仪', '韩林达', '周德明', '何文卷','陈伟锋'],
      form: {
        name: '',
        menuName: [],
        editPermission: false,
      },
      rules: {
        name: [{ required: true, message: '请选择人员', trigger: 'change' }],
      },
    };
  },

  created() {
    this.initUserList();
  },

  computed: {
  },
  methods: {
    async initUserList() {
      try {
        this.loading = true;
        const { data } = await getAuthorityList();
        const userList = data.data.list.map((user) => ({
          ...user,
          menuName: JSON.parse(user.menu_name),
          editPermission: user.edit_permission,
        }));
        localStorage.setItem('userList', JSON.stringify(userList));
        this.userList = userList;
      } catch (error) {
        this.$message.error('获取权限列表失败');
      } finally {
        this.loading = false;
      }
    },
    handleAddUser() {
     
      this.dialogType = 'add';
      this.form = {
        name: '',
        menuName: [],
        resourceManagePermissions: [],
        staffInfoPermissions: [],
      };
      this.dialogVisible = true;
    },
    handleEdit(row) {
      this.dialogType = 'edit';
      this.form = {
        name: row.name,
        menuName: row.menuName,
        editPermission: row.editPermission,
      };
      this.dialogVisible = true;
    },
    async handleSubmit() {
      try {
        await this.$refs.form.validate();
        const formData = {
          name: this.form.name,
          menuName: this.form.menuName,
          editPermission: this.form.editPermission,
        };

        if (this.dialogType === 'add') {
          await createAuthority(formData);
          this.$message.success('添加成功');
        } else {
          const currentUser = this.userList.find((user) => user.name === this.form.name);
          await updateAuthority(currentUser.id, formData);
          this.$message.success('更新成功');
        }

        this.dialogVisible = false;
        this.initUserList();
      } catch (error) {
        this.$message.error(this.dialogType === 'add' ? '添加失败' : '更新失败');
      }
    },
    async handlePermissionChange(row) {
      try {
        const formData = {
          name: row.name,
          menuName: row.menuName,
          editPermission: row.editPermission,
        };
        await updateAuthority(row.id, formData);
        this.$message.success('权限更新成功');
        await this.initUserList();
      } catch (error) {
        row.editPermission = !row.editPermission;
        this.$message.error('权限更新失败');
      }
    },
    async handleDelete(row) {
      try {
        await this.$confirm('确认删除该用户的权限配置？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        });

        await deleteAuthority(row.id);
        this.$message.success('删除成功');
        this.initUserList();
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error('删除失败');
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.authority-container {
  padding: 20px;

  .authority-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    h2 {
      margin: 0;
      font-size: 20px;
      font-weight: 500;
    }
  }

  .permission-status {
    .mt-10 {
      margin-top: 10px;
    }
  }

  .ml-20 {
    margin-left: 20px;
  }

  .delete-btn {
    color: #f56c6c;
  }
}
</style>